import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.3994 7.7998C22.9516 7.7998 23.3993 8.24761 23.3994 8.7998V15.2002C23.3992 15.7523 22.9516 16.2002 22.3994 16.2002H1.59961C1.04754 16.2001 0.59982 15.7522 0.599609 15.2002V8.7998C0.599715 8.24767 1.04748 7.79991 1.59961 7.7998H22.3994ZM1.59961 15.2002H6.39941V8.7998H1.59961V15.2002ZM7.2002 8.7998V15.2002H16.7998V8.7998H7.2002ZM17.5996 11.5996H22.3994V8.7998H17.5996V11.5996ZM22.3994 12.4004H17.5996V15.2002H22.3994V12.4004Z",
		fill: "currentColor"
	})
});
export default SvgWall;
